import { useIsAdminRole } from 'modules/common/hooks/useIsAdminRole';

import ProjectsTabAdmin from './ProjectsTabAdmin';
import ProjectsTabEditor from './ProjectsTabEditor';
import ProjectsTabProofer from './ProjectsTabProofer';
import { useIsProoferRole } from 'modules/common/hooks/useIsProoferRole';
import { useIsEditorRole } from 'modules/common/hooks/useIsEditorRole';

const ProjectsTab = () => {
  const isAdminRole = useIsAdminRole();
  const isEditorRole = useIsEditorRole();
  const isProoferRole = useIsProoferRole();

  return (
    <div className="p-t-3">
      {isAdminRole ? <ProjectsTabAdmin /> : (
        isEditorRole ? <ProjectsTabEditor /> : 
        isProoferRole ? <ProjectsTabProofer /> : null

      )}
    </div>
  );
};

export default ProjectsTab;
